// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const minun: PokeData = {
  "id": 312,
  "name": "minun",
  "height": 4,
  "weight": 42,
  "base_experience": 142,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "growl",
    "thunder-wave",
    "thunder",
    "agility",
    "quick-attack",
    "swift",
    "charm",
    "spark",
    "baton-pass",
    "encore",
    "charge",
    "helping-hand",
    "fake-tears",
    "trump-card",
    "copycat",
    "last-resort",
    "switcheroo",
    "nasty-plot",
    "discharge",
    "electro-ball",
    "entrainment",
    "play-nice",
    "nuzzle"
  ],
  "moves": [
    "growl",
    "thunder",
    "quick-attack",
    "electric-wrath",
    "thunder-fang",
    "volt-crash",
    "electric-terrain",
    "wild-charge",
    "zap-cannon",
    "thunderbolt",
    "thunder-punch",
    "volt-switch",
    "quick-tempo"
  ],
  "evolution_chain": {
    "id": 155,
    "item": null,
    "species": [
      {
        "name": "minun",
        "order": 338,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 109,
    "speed": 163,
    "ability_power": 128
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
